import React, { useState, useEffect } from 'react';

const API_URL = 'https://api.itosoba.ru/api/tariffs/';

function AdminPrivateSectorTariffs() {
  const [tariffs, setTariffs] = useState([]);
  const [form, setForm] = useState({
    tariff_type: '',
    region: '',
    connection_fee: '',    
    advance_payment: '', 
    speed1: '',
    price1: '',
    speed2: '',
    price2: '',
    speed3: '',
    price3: '',
    speed4: '',
    price4: '',
    speed5: '',
    price5: '',
  });
  const [editId, setEditId] = useState(null);

  const fetchTariffs = async () => {
    try {
      const res = await fetch(API_URL);
      if (!res.ok) throw new Error('Ошибка загрузки тарифов');
      const data = await res.json();
      setTariffs(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchTariffs();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...form,
      price1: form.price1 ? parseFloat(form.price1) : null,
      price2: form.price2 ? parseFloat(form.price2) : null,
      price3: form.price3 ? parseFloat(form.price3) : null,
      price4: form.price4 ? parseFloat(form.price4) : null,
      price5: form.price5 ? parseFloat(form.price5) : null,
    };

    try {
      if (editId) {
        const res = await fetch(`${API_URL}${editId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('Ошибка обновления тарифа');
      } else {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('Ошибка создания тарифа');
      }
      setForm({
        tariff_type: '',
        region: '',
        connection_fee: '',
        advance_payment: false,
        speed1: '',
        price1: '',
        speed2: '',
        price2: '',
        speed3: '',
        price3: '',
        speed4: '',
        price4: '',
        speed5: '',
        price5: '',
      });
      setEditId(null);
      fetchTariffs();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = (tariff) => {
    setEditId(tariff.id);
    setForm({
      tariff_type: tariff.tariff_type,
      region: tariff.region,
      description: tariff.description || '',
      advance_payment: tariff.advance_payment || false,
      speed1: tariff.speed1 || '',
      price1: tariff.price1 !== null ? tariff.price1.toString() : '',
      speed2: tariff.speed2 || '',
      price2: tariff.price2 !== null ? tariff.price2.toString() : '',
      speed3: tariff.speed3 || '',
      price3: tariff.price3 !== null ? tariff.price3.toString() : '',
      speed4: tariff.speed4 || '',
      price4: tariff.price4 !== null ? tariff.price4.toString() : '',
      speed5: tariff.speed5 || '',
      price5: tariff.price5 !== null ? tariff.price5.toString() : '',
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Удалить тариф?')) {
      try {
        const res = await fetch(`${API_URL}${id}`, { method: 'DELETE' });
        if (!res.ok) throw new Error('Ошибка удаления тарифа');
        fetchTariffs();
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
      <div>
        <h2>Тарифы (не писать единицы измерения)</h2>
        <form onSubmit={handleSubmit} style={{marginBottom: 20}}>
          <div>
            <label>
              Тип тарифа*:<br/>
              <input
                  type="text"
                  name="tariff_type"
                  value={form.tariff_type}
                  onChange={handleChange}
                  required
              />
            </label>
          </div>
          <div>
            <label>
              Район*:<br/>
              <input
                  type="text"
                  name="region"
                  value={form.region}
                  onChange={handleChange}
                  required
              />
            </label>
          </div>

          <div style={{marginTop: 10}}>
            <label>
              Стоимость подключения:<br/>
              <input
                  type="text"
                  name="connection_fee"
                  value={form.connection_fee}
                  onChange={handleChange}
              />
            </label>
          </div>

          <div style={{marginTop: 10}}>
            <label>
              Авансовый платеж:<br/>
              <input
                  type="text"
                  name="advance_payment"
                  checked={form.advance_payment}
                  onChange={handleChange}
              />
            </label>
          </div>

          {[1, 2, 3, 4, 5].map(n => (
              <div key={n} style={{marginTop: 10}}>
                <label>
                  Скорость {n}:<br/>
                  <input
                      type="text"
                      name={`speed${n}`}
                      value={form[`speed${n}`]}
                      onChange={handleChange}
                  />
                </label>
                <label style={{marginLeft: 10}}>
                  Стоимость {n}:<br/>
                  <input
                      type="number"
                      step="0.01"
                      name={`price${n}`}
                      value={form[`price${n}`]}
                      onChange={handleChange}
                  />
                </label>
              </div>
          ))}

          <button type="submit" style={{marginTop: 15}}>
            {editId ? 'Сохранить изменение' : 'Добавить тариф'}
          </button>
          {editId && (
              <button
                  type="button"
                  onClick={() => {
                    setEditId(null);
                    setForm({
                      tariff_type: '',
                      region: '',
                      connection_fee: '',
                      advance_payment: false,
                      speed1: '',
                      price1: '',
                      speed2: '',
                      price2: '',
                      speed3: '',
                      price3: '',
                      speed4: '',
                      price4: '',
                      speed5: '',
                      price5: '',
                    });
                  }}
                  style={{marginLeft: 10}}
              >
                Отмена
              </button>
          )}
        </form>

        <table border="1" cellPadding="5" cellSpacing="0" style={{width: '100%', borderCollapse: 'collapse'}}>
          <thead>
          <tr>
            <th>ID</th>
            <th>Тип тарифа</th>
            <th>Район</th>
            <th>Стоимость подключения</th>
            <th>Авансовый платеж</th>
            {[1, 2, 3, 4, 5].map(n => (
                <React.Fragment key={n}>
                  <th>Скорость {n}</th>
                  <th>Стоимость {n}</th>
                </React.Fragment>
            ))}
            <th>Действия</th>
          </tr>
          </thead>
          <tbody>
          {tariffs.length > 0 ? (
              tariffs.map(tariff => (
                  <tr key={tariff.id}>
                    <td>{tariff.id}</td>
                    <td>{tariff.tariff_type}</td>
                    <td>{tariff.region}</td>
                    <td>{tariff.connection_fee !== null && tariff.connection_fee !== undefined ? tariff.connection_fee : '-'}</td>
                    <td>{tariff.advance_payment !== null && tariff.advance_payment !== undefined ? tariff.advance_payment : '-'}</td>
                    {[1, 2, 3, 4, 5].map(n => (
                        <React.Fragment key={n}>
                          <td>{tariff[`speed${n}`] !== null && tariff[`speed${n}`] !== undefined ? tariff[`speed${n}`] : '-'}</td>
                          <td>{tariff[`price${n}`] !== null && tariff[`price${n}`] !== undefined ? tariff[`price${n}`] : '-'}</td>
                        </React.Fragment>
                    ))}
                    <td>
                      <button onClick={() => handleEdit(tariff)}>Редактировать</button>
                      {' '}
                      <button onClick={() => handleDelete(tariff.id)}>Удалить</button>
                    </td>
                  </tr>
              ))
          ) : (
              <tr>
                <td colSpan={3 + 2 * 5} style={{textAlign: 'center'}}>
                  Нет тарифов
                </td>
              </tr>
          )}
          </tbody>
        </table>
      </div>
  );
}

export default AdminPrivateSectorTariffs;